import { useFormContext } from "react-hook-form";
import { ErrorMessage, PasswordInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { AddClientFormData } from "../types";

export const PasswordField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<AddClientFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">Password</Typography>
      <PasswordInput
        className="w-full"
        hasError={!!errors.password}
        placeholder="Enter password"
        autoComplete="new-password"
        maxLength={65}
        {...register("password")}
      />
      <Typography variant="small" className="text-neutral-dark-gray">
        Note: minimum of 6 characters
      </Typography>
      <ErrorMessage errors={errors} name="password" />
    </div>
  );
};
